import React from "react"

import { withCustomerOrdersCard } from "./withCustomerOrdersCard"
import { CustomerOrdersList } from "../List/CustomerOrdersList"

export const CustomerOrdersCard = withCustomerOrdersCard(
  ({ orders, loading, error, additionalOrderNo, additionalDate, additionalStatus, additionalTotalPrice, additionalMore }): JSX.Element => (
    <>
      {loading ? (
        <p>{`Loading...`}</p>
      ) : (
        <CustomerOrdersList
          orders={orders}
          loading={loading}
          error={error}
          additionalOrderNo={additionalOrderNo}
          additionalDate={additionalDate}
          additionalStatus={additionalStatus}
          additionalTotalPrice={additionalTotalPrice}
          additionalMore={additionalMore}
        />
      )}
    </>
  )
)
